import productImage from '../assets/images/toallas.png'
import productImageCL from '../assets/images/calzon-nocturno.png'
import productImagePE from '../assets/images/packShotPE.png'

export const ENV = process.env.ENVIRONMENT ? process.env.ENVIRONMENT : 'DEV'
export const LOCALE = process.env.LOCALE


export const concourseId = {
  DEV: 189,
  PDN: 191,
}[ENV]

export const storeURL = {
  'es-CO': 'https://www.nosotrasonline.com.co/productos/tiendas/',
  'es-CL': 'https://www.nosotrasonline.cl/productos/tiendas/',
}[LOCALE]

export const costActivity = 30
export const costHelpActivity = 10


export const packShot = {
  'es-CO': productImage,
  'es-CL': productImageCL,
  'es-PE': productImagePE,
  'es-DO': productImage,
  'es-EC': productImage,
}[LOCALE]

export const textChange = {
  'es-CO': {
    text_1: 'Buenas Noches',
    text_2: 'conócelas',
    text_3: 'Suave tela respirable para que te despiertes fresca y cómoda',
    text_4: 'Utiliza una sola toalla por noche para dormir sin interrupciones',
    text_5: 'Toalla absorbente de máxima protección para flujo súper abundante',
    text_6: 'Puedes escoger la talla según la talla de tu panty.',
    text_7: 'Toallas absorbentes de máxima seguridad',
    text_8: 'Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, son tan prácticas como tu ropa interior. Aprende cómo usarlas y desecharlas:',
    text_9: 'Usar como un panty',
    text_10: 'Retirar como un panty normal',
    text_11: 'Dobla la toalla',
    text_12: 'Para identificar tu talla de panty mide con un metro el contorno de tu cadera.',
    text_13: 'Haz clic y conoce cada detalle del diseño innovador que ofrecen las nuevas Toallas Nosotras Buenas Noches Máxima Protección.',
  },
  'es-CL': {
    text_1: 'Calzón Nocturno',
    text_2: 'conócelos',
    text_3: 'Suave tela respirable para que despiertes fresca y cómoda',
    text_4: 'Utiliza un solo Calzón Nocturno por noche para dormir sin interrupciones',
    text_5: 'Calzón Nocturno absorbente de máxima protección para flujo súper abundante',
    text_6: 'Puedes escoger la talla según la talla de tu ropa interior.',
    text_7: 'Calzón Nocturno absorbente de máxima seguridad',
    text_8: 'El nuevo Calzón Nocturno Nosotras Máxima Protección, es tan práctico como tu ropa interior. Aprende cómo usarlos y desecharlos:',
    text_9: 'Usar como ropa interior',
    text_10: 'Retirar como la ropa interior normal',
    text_11: 'Dobla el calzón',
    text_12: 'Para identificar tu talla de ropa interior mide con un metro el contorno de tu cadera.',
    text_13: 'Haz clic y conoce cada detalle del diseño innovador que ofrece el Nuevo Calzón Nocturno Nosotras Máxima Protección.',
  },
  'es-PE': {
    text_1: 'Calzón Nocturno',
    text_2: 'conócelos',
    text_3: 'Suave tela respirable para que despiertes fresca y cómoda',
    text_4: 'Utiliza un solo Calzón Nocturno por noche para dormir sin interrupciones',
    text_5: 'Calzón Nocturno absorbente de máxima protección para flujo súper abundante',
    text_6: 'Puedes escoger la talla según la talla de tu ropa interior.',
    text_7: 'Calzón Nocturno absorbente de máxima seguridad',
    text_8: 'El nuevo Calzón Nocturno Nosotras Máxima Protección, es tan práctico como tu ropa interior. Aprende cómo usarlos y desecharlos:',
    text_9: 'Usar como ropa interior',
    text_10: 'Retirar como la ropa interior normal',
    text_11: 'Dobla el calzón',
    text_12: 'Para identificar tu talla de ropa interior mide con un metro el contorno de tu cadera.',
    text_13: 'Haz clic y conoce cada detalle del diseño innovador que ofrece el Nuevo Calzón Nocturno Nosotras Máxima Protección.',
  },
  'es-DO': {
    text_1: 'Buenas Noches',
    text_2: 'conócelos',
    text_3: 'Suave tela respirable para que te despiertes fresca y cómoda',
    text_4: 'Utiliza un solo panty por noche para dormir sin interrupciones.',
    text_5: 'Panty absorbente de máxima protección para flujo súper abundante',
    text_6: 'Puedes escoger la talla según la talla de tu panty.',
    text_7: 'Pantys absorbentes de máxima seguridad',
    text_8: 'El Nuevo Nosotras Panty Nocturno con Máxima Protección 360, son tan prácticos como tu ropa interior. Aprende cómo usarlos y desecharlos:',
    text_9: 'Usar como un panty',
    text_10: 'Retirar como un panty normal',
    text_11: 'Dobla el panty',
    text_12: 'Para identificar tu talla de panty mide con un metro el contorno de tu cadera.',
    text_13: 'Haz clic y conoce cada detalle del diseño innovador que ofrecen el Nuevo Nosotras Panty Nocturno con Máxima Protección 360.',
  },
  'es-EC': {
    text_1: 'Buenas Noches',
    text_2: 'conócelas',
    text_3: 'Suave tela respirable para que te despiertes fresca y cómoda',
    text_4: 'Utiliza una sola toalla por noche para dormir sin interrupciones',
    text_5: 'Toalla absorbente de máxima protección para flujo súper abundante',
    text_6: 'Puedes escoger la talla según la talla de tu panty.',
    text_7: 'Toallas absorbentes de máxima seguridad',
    text_8: 'Las nuevas Toallas Nosotras Buenas Noches Máxima Protección, son tan prácticas como tu ropa interior. Aprende cómo usarlas y desecharlas:',
    text_9: 'Usar como un panty',
    text_10: 'Retirar como un panty normal',
    text_11: 'Dobla la toalla',
    text_12: 'Para identificar tu talla de panty mide con un metro el contorno de tu cadera.',
    text_13: 'Haz clic y conoce cada detalle del diseño innovador que ofrecen las nuevas Toallas Nosotras Buenas Noches Máxima Protección.',
  },
}[LOCALE]

export const socialMedia = {
  'es-CO': {
    facebook: 'https://www.facebook.com/NosotrasColombia/',
    instagram: 'https://www.instagram.com/nosotras/',
    twitter: 'https://twitter.com/YoAmoNosotras',
    youtube: 'https://www.youtube.com/user/videosNosotras',
    tiktok: 'https://www.tiktok.com/@nosotraslatam?_d=secCgsIARCbDRgBIAIoARI%2BCjzHMWAAHc4QUM2mLQqLMSfSM4JvqjttDWxk894tMRafzgyEWc%2FSud4s3iSdevW3OKYJW%2Bqdunqe0eXNEoYaAA%3D%3D&language=es&sec_uid=MS4wLjABAAAAEZEjxWG75Cn2MoJ_mJbc6ihjiHa6JE-YstZy-MaVFLDITjE5FIXTv6AvOEjImCNS&sec_user_id=MS4wLjABAAAAlEfo7lUs1wJ6zDXvhz2n_Ua03Hy0to8T_Iqx-jMOY1IznWqOq_fkHphFIPaYvG1C&share_app_name=musically&share_author_id=6783002169403737093&share_link_id=2645c2cb-bc09-45e4-88b3-2f6aa6f10bf3&timestamp=1597337993&u_code=dadb4b76g87e75&user_id=6784469258829300742&utm_campaign=client_share&utm_medium=android&utm_source=copy&source=h5_m&_r=1',
  },
  'es-CL': {
    facebook: 'https://www.facebook.com/nosotraschile/',
    instagram: 'https://www.instagram.com/nosotraschile/',
    twitter: 'https://twitter.com/nosotraschile',
    youtube: 'https://www.youtube.com/user/videosNosotras',
    tiktok: 'https://www.tiktok.com/@nosotraslatam?_d=secCgsIARCbDRgBIAIoARI%2BCjzHMWAAHc4QUM2mLQqLMSfSM4JvqjttDWxk894tMRafzgyEWc%2FSud4s3iSdevW3OKYJW%2Bqdunqe0eXNEoYaAA%3D%3D&language=es&sec_uid=MS4wLjABAAAAEZEjxWG75Cn2MoJ_mJbc6ihjiHa6JE-YstZy-MaVFLDITjE5FIXTv6AvOEjImCNS&sec_user_id=MS4wLjABAAAAlEfo7lUs1wJ6zDXvhz2n_Ua03Hy0to8T_Iqx-jMOY1IznWqOq_fkHphFIPaYvG1C&share_app_name=musically&share_author_id=6783002169403737093&share_link_id=2645c2cb-bc09-45e4-88b3-2f6aa6f10bf3&timestamp=1597337993&u_code=dadb4b76g87e75&user_id=6784469258829300742&utm_campaign=client_share&utm_medium=android&utm_source=copy&source=h5_m&_r=1',
  },
  'es-PE': {
    facebook: 'https://www.facebook.com/nosotrasPeru/',
    instagram: 'https://www.instagram.com/nosotrasperu/',
    twitter: 'https://twitter.com/YoAmoNosotras',
    youtube: 'https://www.youtube.com/user/videosNosotras',
    tiktok: 'https://www.tiktok.com/@nosotraslatam?_d=secCgsIARCbDRgBIAIoARI%2BCjzHMWAAHc4QUM2mLQqLMSfSM4JvqjttDWxk894tMRafzgyEWc%2FSud4s3iSdevW3OKYJW%2Bqdunqe0eXNEoYaAA%3D%3D&language=es&sec_uid=MS4wLjABAAAAEZEjxWG75Cn2MoJ_mJbc6ihjiHa6JE-YstZy-MaVFLDITjE5FIXTv6AvOEjImCNS&sec_user_id=MS4wLjABAAAAlEfo7lUs1wJ6zDXvhz2n_Ua03Hy0to8T_Iqx-jMOY1IznWqOq_fkHphFIPaYvG1C&share_app_name=musically&share_author_id=6783002169403737093&share_link_id=2645c2cb-bc09-45e4-88b3-2f6aa6f10bf3&timestamp=1597337993&u_code=dadb4b76g87e75&user_id=6784469258829300742&utm_campaign=client_share&utm_medium=android&utm_source=copy&source=h5_m&_r=1',
  },
  'es-DO': {
    facebook: 'https://www.facebook.com/NosotrasRD?fref=ts',
    instagram: 'https://www.instagram.com/nosotrasrd/',
    twitter: 'https://twitter.com/NosotrasRD',
    youtube: 'https://www.youtube.com/user/videosNosotras',
    tiktok: 'https://www.tiktok.com/@nosotraslatam?_d=secCgsIARCbDRgBIAIoARI%2BCjzHMWAAHc4QUM2mLQqLMSfSM4JvqjttDWxk894tMRafzgyEWc%2FSud4s3iSdevW3OKYJW%2Bqdunqe0eXNEoYaAA%3D%3D&language=es&sec_uid=MS4wLjABAAAAEZEjxWG75Cn2MoJ_mJbc6ihjiHa6JE-YstZy-MaVFLDITjE5FIXTv6AvOEjImCNS&sec_user_id=MS4wLjABAAAAlEfo7lUs1wJ6zDXvhz2n_Ua03Hy0to8T_Iqx-jMOY1IznWqOq_fkHphFIPaYvG1C&share_app_name=musically&share_author_id=6783002169403737093&share_link_id=2645c2cb-bc09-45e4-88b3-2f6aa6f10bf3&timestamp=1597337993&u_code=dadb4b76g87e75&user_id=6784469258829300742&utm_campaign=client_share&utm_medium=android&utm_source=copy&source=h5_m&_r=1',
  },
  'es-EC': {
    facebook: 'https://www.facebook.com/NosotrasEcuador',
    instagram: 'https://www.instagram.com/nosotrasecuador/',
    // twitter: 'https://twitter.com/YoAmoNosotras',
    youtube: 'https://www.youtube.com/user/videosNosotras',
    tiktok: 'https://www.tiktok.com/@nosotraslatam?_d=secCgsIARCbDRgBIAIoARI%2BCjzHMWAAHc4QUM2mLQqLMSfSM4JvqjttDWxk894tMRafzgyEWc%2FSud4s3iSdevW3OKYJW%2Bqdunqe0eXNEoYaAA%3D%3D&language=es&sec_uid=MS4wLjABAAAAEZEjxWG75Cn2MoJ_mJbc6ihjiHa6JE-YstZy-MaVFLDITjE5FIXTv6AvOEjImCNS&sec_user_id=MS4wLjABAAAAlEfo7lUs1wJ6zDXvhz2n_Ua03Hy0to8T_Iqx-jMOY1IznWqOq_fkHphFIPaYvG1C&share_app_name=musically&share_author_id=6783002169403737093&share_link_id=2645c2cb-bc09-45e4-88b3-2f6aa6f10bf3&timestamp=1597337993&u_code=dadb4b76g87e75&user_id=6784469258829300742&utm_campaign=client_share&utm_medium=android&utm_source=copy&source=h5_m&_r=1',
  },
}[LOCALE]

export const urlMuestreo = {
  'es-CO': 'https://www.nosotrasonline.com.co/productos/durante-tu-periodo/toallas-higienicas/toallas-buenas-noches-maxima-proteccion/',
  'es-CL': 'https://www.nosotrasonline.cl/',
  'es-PE': '',
  'es-EC': '#',
}[LOCALE]
